import React from 'react';
import PropTypes from 'prop-types';
import {BoldText, DateRenderer} from "../../../components";
import styled from 'styled-components';

const Controls = styled.div`
  display: inline-flex;
  width: 100%;
  margin: 1em 0;
`;

const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around  
`;

const RecordUploadInfo = ({record}) => (
  <Controls>
    <Container>
      <div>
        <BoldText>Last Saved By:</BoldText>
        <div>{record.lastSavedBy}</div>
      </div>
      <div>
        <BoldText>Review Status:</BoldText>
        <div>{record.recordStatus}</div>
      </div>
      <div>
        <BoldText>Status Date:</BoldText>
        <div><DateRenderer value={record.statusDate}/></div>
      </div>
    </Container>
  </Controls>
);

RecordUploadInfo.propTypes = {
  record: PropTypes.object.isRequired,
};

export default RecordUploadInfo;



// WEBPACK FOOTER //
// ./src/modules/record/components/RecordUploadInfo.js